import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-975ef288"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "操作提示："),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "设置商家入驻协议，需同意协议才能提交入驻申请。"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "您可以在下面的编辑框中,编辑更新入驻协议内容。")
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("更新入驻协议")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "协议内容" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", null, [
          _createVNode(_component_EditorComponent, {
            ref: "editorComponentRef",
            "is-extra": false,
            content: _ctx.data.content,
            extra: _ctx.enclosure
          }, null, 8, ["content", "extra"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"margin-top":"30px"},
            onClick: $setup.updateAgrement
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}